import {
  startOfWeek,
  endOfWeek,
  addDays,
  subDays,
  startOfMonth,
  endOfMonth,
  addMonths,
  subMonths,
  startOfYear,
  endOfYear,
  addYears,
  subYears,
} from 'date-fns'

const today = new Date()

export const THIS_WEEK = {
  label: 'This week',
  getValue: () => {
    return [startOfWeek(today), endOfWeek(today)]
  },
}

export const LAST_WEEK = {
  label: 'Last week',
  getValue: () => {
    const prevWeek = subDays(today, 7)
    return [startOfWeek(prevWeek), endOfWeek(prevWeek)]
  },
}

export const LAST_7_DAYS = {
  label: 'Last 7 Days',
  getValue: () => {
    const last7Days = subDays(today, 6)
    return [last7Days, today]
  },
}

export const LAST_30_DAYS = {
  label: 'Last 30 Days',
  getValue: () => {
    const last30Days = subDays(today, 29)
    return [last30Days, today]
  },
}

export const LAST_90_DAYS = {
  label: 'Last quarter',
  getValue: () => {
    const last90Days = subDays(today, 89)
    return [last90Days, today]
  },
}

export const NEXT_WEEK = {
  label: 'Next week',
  getValue: () => {
    const nextWeek = addDays(today, 7)
    return [startOfWeek(nextWeek), endOfWeek(nextWeek)]
  },
}

export const NEXT_7_DAYS = {
  label: 'Next 7 Days',
  getValue: () => {
    const next7Days = addDays(today, 6)
    return [today, next7Days]
  },
}

export const TWO_WEEKS = {
  label: '2 weeks',
  getValue: () => {
    const nextWeek = addDays(today, 7)
    return [startOfWeek(today), endOfWeek(nextWeek)]
  },
}

export const CURRENT_MONTH = {
  label: 'Current month',
  getValue: () => {
    return [startOfMonth(today), endOfMonth(today)]
  },
}

export const LAST_MONTH = {
  label: 'Last month',
  getValue: () => {
    const lastMonth = subMonths(today, 1)
    return [startOfMonth(lastMonth), endOfMonth(lastMonth)]
  },
}

export const NEXT_MONTH = {
  label: 'Next month',
  getValue: () => {
    const nextMonth = addMonths(today, 1)
    return [startOfMonth(nextMonth), endOfMonth(nextMonth)]
  },
}

export const CURRENT_YEAR = {
  label: 'Current year',
  getValue: () => {
    return [startOfYear(today), endOfYear(today)]
  },
}

export const LAST_YEAR = {
  label: 'Last year',
  getValue: () => {
    return [startOfYear(subYears(today, 1)), endOfYear(subYears(today, 1))]
  },
}

export const NEXT_YEAR = {
  label: 'Next year',
  getValue: () => {
    return [startOfYear(addYears(today, 1)), endOfYear(addYears(today, 1))]
  },
}

export const RESET = {
  label: 'Reset',
  getValue: () => [null, null],
}

export const shortcutsItems = [{ ...THIS_WEEK }, { ...LAST_WEEK }, { ...NEXT_WEEK }, { ...TWO_WEEKS }, { ...RESET }]
